import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import EditOpportunitySecurityChecklistWindowDescription from './EditOpportunitySecurityChecklistWindowDescription';

class OpportunitySearchParams extends SearchParamsBase {
  static saveType = 'OpportunitySearchParams';
  initialize() {
    this.OpportunityName = '';
    // this.OpportunityId = "";
    this.ClientId = '';
    this.UseFollowUpDateRange = false;
    this.FollowUpDateOnOrAfter = dateTimeHelper.indefiniteDateValue();
    this.FollowUpDateOnOrBefore = dateTimeHelper.indefiniteDateValue();
    this.StatusCode = [];
    this.UninvoicedOtherFees = false;
    this.OwningOffices = [];
    this.IsGlobal = '';
    this.IsMultiOffice = '';
    this.PrimarySalesRep = '';
    this.Owner = '';
    this.AssignedTo = '';
    this.Industry = '';
    this.UseCreatedOnDateRange = false;
    this.CreatedOnOrAfter = dateTimeHelper.indefiniteDateValue();
    this.CreatedOnOrBefore = dateTimeHelper.indefiniteDateValue();
    this.OpportunityType = [];
    this.ApprovedLogoUsage = '';
    this.ApprovedNameUsage = '';
    // Security Checklist presets (CD-5441). Five are one-directional (only "on" filters; the backend
    // ignores false), so they default to a boolean false like UninvoicedOtherFees. InfoSecContactDefined
    // is the one tri-state, so it defaults to '' — blank meaning "don't filter", as for IsGlobal.
    this.SecurityChecklistIncomplete = false;
    this.InfoSecContactDefined = '';
    this.DataTransferOverdue = false;
    this.DataTransferComplete = false;
    this.DataErasureOverdue = false;
    this.DataRetentionExpiringSoon = false;
  }

  static fieldsInSearchBox = [
    { fieldName: 'ClientId', label: 'Client Name or Id', className: 'col-4', type: InputTypesEnum.Text },
    // { fieldName: "OpportunityId", label: "Opportunity Id", className: "col-4", type: InputTypesEnum.Number },
    { fieldName: 'OpportunityName', label: 'Opportunity Name or Id', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'StatusCode',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 19,
    },
    {
      fieldName: 'UseFollowUpDateRange',
      label: 'Use Follow Up Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'FollowUpDateOnOrAfter',
      label: 'Follow Up On Or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseFollowUpDateRange,
    },
    {
      fieldName: 'FollowUpDateOnOrBefore',
      label: 'Follow Up On Or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseFollowUpDateRange,
    },
    {
      fieldName: 'UninvoicedOtherFees',
      label: 'Uninvoiced Other Fees',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'OwningOffices',
      label: 'Owning Offices',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'IsGlobal', label: 'Global', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'IsMultiOffice', label: 'Multi Office', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'PrimarySalesRep', label: 'Primary Sales Rep', className: 'col-4', type: InputTypesEnum.UserSelect },
    { fieldName: 'Owner', label: 'Owner', className: 'col-4', type: InputTypesEnum.UserSelect },
    { fieldName: 'AssignedTo', label: 'Assigned To', className: 'col-4', type: InputTypesEnum.UserSelect },
    { fieldName: 'Industry', label: 'Industry', className: 'col-4', type: InputTypesEnum.IndustryLookupItemSelect },
    {
      fieldName: 'UseCreatedOnDateRange',
      label: 'Use Created On Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'CreatedOnOrAfter',
      label: 'Created On Or After',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCreatedOnDateRange,
    },
    {
      fieldName: 'CreatedOnOrBefore',
      label: 'Created On Or Before',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCreatedOnDateRange,
    },
    {
      fieldName: 'OpportunityType',
      label: 'Opportunity Type',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 72,
    },
    {
      fieldName: 'ApprovedLogoUsage',
      label: 'Client Logo Usage Approved',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: OpportunitySearchParams.getClientApprovedOptions(),
    },
    {
      fieldName: 'ApprovedNameUsage',
      label: 'Client Name Usage Approved',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: OpportunitySearchParams.getClientApprovedOptions(),
    },
    // Security Checklist presets (CD-5441). Deliberately appended to the flat panel rather than moved onto
    // a `tabsOnTheSearchPanel` tab of their own: GeneralSearchPanelFigma renders a field with no `tab` on
    // EVERY tab, so introducing tabs here would mean tagging all the fields above as well.
    {
      fieldName: 'SecurityChecklistIncomplete',
      label: 'Security Checklist Incomplete',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'InfoSecContactDefined',
      label: 'InfoSec Contact Defined',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    {
      fieldName: 'DataTransferOverdue',
      label: 'Data Transfer Overdue',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'DataTransferComplete',
      label: 'Data Transfer Complete',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'DataErasureOverdue',
      label: 'Data Erasure Overdue',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'DataRetentionExpiringSoon',
      label: 'Data Retention Expiring Soon',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
  ];

  static getClientApprovedOptions() {
    return [{ label: '', value: '' }, ...EditOpportunitySecurityChecklistWindowDescription.getClientApprovedValues()];
  }

  static iconName = 'fa-solid fa-search';
}
export default OpportunitySearchParams;
